import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import { Link } from 'react-scroll';

// Note: Replace with your actual logo path
const logoPath = '/logo.png'; 

const Nav = styled.nav`
  background: rgba(0, 0, 0, 0.7);
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  transition: all 0.3s ease;
  box-shadow: ${theme.boxShadow};
  
  @media screen and (max-width: 960px) {
    height: 80px;
  }
`;

const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 140px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1300px;
  
  @media screen and (max-width: 960px) {
    height: 80px;
    padding: 0 16px;
  }
`;

const NavLogo = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;
  
  span {
    @media screen and (max-width: 960px) {
      font-size: 1rem;
    }
    
    @media screen and (max-width: 480px) {
      display: none;
    }
  }
`;

const Logo = styled.img`
  height: 100px !important;
  width: auto !important;
  margin-right: 10px;
  
  @media screen and (max-width: 960px) {
    height: 60px !important;
  }
`;

const MobileIcon = styled.div`
  display: none;
  
  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    font-size: 1.8rem;
    cursor: pointer;
    color: ${theme.colors.accent};
    z-index: 1000;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: ${({ isOpen }) => (isOpen ? '80px' : '-100%')};
    left: 0;
    opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
    transition: all 0.5s ease;
    background: #fff;
    z-index: 999;
    padding-top: 20px;
    overflow-y: auto;
    align-items: flex-start;
  }
`;

const NavItem = styled.li`
  height: 80px;
  position: relative;
  
  @media screen and (max-width: 960px) {
    width: 100%;
    height: auto;
    min-height: 60px;
  }
`;

const NavLink = styled(Link)`
  color: ${({ scrolled }) => scrolled ? theme.colors.accent : theme.colors.textLight};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 3px;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${theme.colors.accent};
    transition: width 0.3s;
  }
  
  &:hover:after {
    width: 70%;
  }
  
  &:hover {
    color: ${theme.colors.accent};
  }
  
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 1rem 2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    color: ${theme.colors.dark};
    
    &:after {
      display: none;
    }
    
    &:hover {
      color: ${theme.colors.accent};
      transition: all 0.3s ease;
    }
  }
`;

const PageNavLink = styled.a`
  color: ${({ scrolled }) => scrolled ? theme.colors.accent : theme.colors.textLight};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 3px;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${theme.colors.accent};
    transition: width 0.3s;
  }
  
  &:hover:after {
    width: 70%;
  }
  
  &:hover {
    color: ${theme.colors.accent};
  }
  
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 1rem 2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    color: ${theme.colors.dark};
    
    &:after {
      display: none;
    }
    
    &:hover {
      color: ${theme.colors.accent};
      transition: all 0.3s ease;
    }
  }
`;

const DropdownPageNavLink = styled.a`
  color: ${({ scrolled }) => scrolled ? theme.colors.accent : theme.colors.textLight};
  display: block;
  text-decoration: none;
  padding: 8px 0;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  position: relative;
  text-align: left;
  
  border-bottom: 2px solid transparent;
  
  &:hover {
    color: ${theme.colors.accent};
    border-bottom: 2px solid ${theme.colors.accent};
  }
  
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 0.75rem 1rem;
    width: 100%;
    display: block;
    color: ${theme.colors.dark};
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
`;

// Dropdown Menu Styling
const DropdownWrapper = styled.div`
  position: relative;
  height: 100%;
  
  @media screen and (max-width: 960px) {
    height: auto;
    width: 100%;
  }
`;

// Modified to be more like a Link component that can be clicked
const DropdownButton = styled(Link)`
  color: ${({ scrolled }) => scrolled ? theme.colors.accent : theme.colors.textLight};
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  height: 100%;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  position: relative;
  background: none;
  border: none;
  font-size: 16px;
  font-family: ${theme.fonts.body};
  
  svg {
    margin-left: 5px;
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 3px;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${theme.colors.accent};
    transition: width 0.3s;
  }
  
  &:hover:after {
    width: 70%;
  }
  
  &:hover {
    color: ${theme.colors.accent};
  }
  
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 1rem 2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    color: ${theme.colors.dark};
    
    &:after {
      display: none;
    }
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 80px;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  border-radius: ${theme.borderRadius};
  padding: 1rem 0;
  width: 280px;
  box-shadow: ${theme.boxShadow};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: translateY(${({ isOpen }) => (isOpen ? '0' : '-10px')});
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  z-index: 10;
  
  @media screen and (max-width: 960px) {
    position: static;
    background: none;
    padding: 0;
    box-shadow: none;
    width: 100%;
    opacity: 1;
    visibility: visible;
    transform: none;
  }
`;

const DropdownItem = styled.div`
  padding: 0.5rem 1.5rem;
  position: relative;
  white-space: nowrap;
  
  @media screen and (max-width: 960px) {
    padding: 0.25rem 0;
    white-space: normal;
  }
`;

const NavButton = styled.div`
  display: flex;
  align-items: center;
  
  @media screen and (max-width: 960px) {
    display: none;
  }
`;

const Button = styled.button`
  background: ${theme.colors.accent};
  white-space: nowrap;
  padding: 10px 20px;
  color: ${theme.colors.textLight};
  font-size: 16px;
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: ${theme.borderRadius};
  
  &:hover {
    background: ${theme.colors.accentLight};
    transform: translateY(-2px);
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  // Determine current page - check the actual current page from App state
  const isHomePage = (window.currentPage || 'home') === 'home';

  const toggle = () => setIsOpen(!isOpen);
  
  useEffect(() => {
    const changeNav = () => {
      // Get the position of the About section
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        const aboutPosition = aboutSection.getBoundingClientRect().top;
        // Change color when the About section is at or near the top of the viewport
        if (aboutPosition <= 100) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      } else {
        // Fallback to the original scroll behavior if section not found
        if (window.scrollY >= 80) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
    };
    
    window.addEventListener('scroll', changeNav);
    return () => {
      window.removeEventListener('scroll', changeNav);
    };
  }, []);

  const handlePageNavigation = (page, section) => {
    // Use the global navigation function defined in App.js
    if (window.navigateTo) {
      window.navigateTo(page, section);
    }
    setDropdownOpen(false);
    setIsOpen(false); // Close mobile menu when navigating
  };

  // Handle dropdown toggle
  const toggleDropdown = (e) => {
    e.preventDefault(); // Prevent the Link from scrolling
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const closeDropdown = (e) => {
      if (dropdownOpen && !e.target.closest('.dropdown-container')) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', closeDropdown);
    return () => document.removeEventListener('click', closeDropdown);
  }, [dropdownOpen]);

  return (
    <Nav scrolled={scrolled}>
      <NavbarContainer>
        <NavLogo onClick={() => handlePageNavigation('home')}>
          <Logo src={logoPath} alt="Rewilding Therapies Logo" />
          <span style={{ color: scrolled ? theme.colors.accent : theme.colors.textLight }}>
            Rewilding Therapies
          </span>
        </NavLogo>
        <MobileIcon onClick={toggle}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </MobileIcon>
        <NavMenu isOpen={isOpen}>
          {isHomePage ? (
            // Home page navigation - scroll links
            <>
              <NavItem>
                <NavLink 
                  to="home" 
                  smooth={true} 
                  duration={500} 
                  spy={true} 
                  exact="true" 
                  offset={-80}
                  scrolled={scrolled}
                  onClick={() => setIsOpen(false)}
                >
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  to="about" 
                  smooth={true} 
                  duration={500} 
                  spy={true} 
                  exact="true" 
                  offset={-80}
                  scrolled={scrolled}
                  onClick={() => setIsOpen(false)}
                >
                  About
                </NavLink>
              </NavItem>
              <NavItem>
                <DropdownWrapper className="dropdown-container">
                  {/* The main button now has both scroll functionality */}
                  <DropdownButton 
                    to="services"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-80}
                    scrolled={scrolled}
                    onClick={toggleDropdown}
                  >
                    Services <FaChevronDown />
                  </DropdownButton>
                  <DropdownMenu isOpen={dropdownOpen}>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('wilderness-therapy');
                        }}
                        scrolled={scrolled}
                      >
                        Wilderness Therapy
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('group-wilderness-therapy');
                        }}
                        scrolled={scrolled}
                      >
                        Group Therapy
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('movement-coaching');
                        }}
                        scrolled={scrolled}
                      >
                        Movement Coaching
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('corporate-wellbeing');
                        }}
                        scrolled={scrolled}
                      >
                        Corporate Wellbeing
                      </DropdownPageNavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </DropdownWrapper>
              </NavItem>
              <NavItem>
                <NavLink 
                  to="about-me" 
                  smooth={true} 
                  duration={500} 
                  spy={true} 
                  exact="true" 
                  offset={-80}
                  scrolled={scrolled}
                  onClick={() => setIsOpen(false)}
                >
                  About Me
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  to="contact" 
                  smooth={true} 
                  duration={500} 
                  spy={true} 
                  exact="true" 
                  offset={-80}
                  scrolled={scrolled}
                  onClick={() => setIsOpen(false)}
                >
                  Contact
                </NavLink>
              </NavItem>
            </>
          ) : (
            // Service page navigation
            <>
              <NavItem>
                <PageNavLink 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageNavigation('home');
                  }}
                  scrolled={scrolled}
                >
                  Home
                </PageNavLink>
              </NavItem>
              <NavItem>
                <PageNavLink 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageNavigation('home', 'about');
                  }}
                  scrolled={scrolled}
                >
                  About
                </PageNavLink>
              </NavItem>
              <NavItem>
                <DropdownWrapper className="dropdown-container">
                  <DropdownButton 
                    to="#"
                    scrolled={scrolled} 
                    onClick={toggleDropdown}
                  >
                    Services <FaChevronDown />
                  </DropdownButton>
                  <DropdownMenu isOpen={dropdownOpen}>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('wilderness-therapy');
                        }}
                        scrolled={scrolled}
                      >
                        Wilderness Therapy
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('group-wilderness-therapy');
                        }}
                        scrolled={scrolled}
                      >
                        Group Therapy
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('movement-coaching');
                        }}
                        scrolled={scrolled}
                      >
                        Movement Coaching
                      </DropdownPageNavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <DropdownPageNavLink 
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageNavigation('corporate-wellbeing');
                        }}
                        scrolled={scrolled}
                      >
                        Corporate Wellbeing
                      </DropdownPageNavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </DropdownWrapper>
              </NavItem>
              <NavItem>
                <PageNavLink 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageNavigation('home', 'about-me');
                  }}
                  scrolled={scrolled}
                >
                  About Me
                </PageNavLink>
              </NavItem>
              <NavItem>
                <PageNavLink 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageNavigation('home', 'contact');
                  }}
                  scrolled={scrolled}
                >
                  Contact
                </PageNavLink>
              </NavItem>
            </>
          )}
        </NavMenu>
        <NavButton>
          <Button onClick={() => window.location.href = "#contact"}>Get Started</Button>
        </NavButton>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;